import { useState, useEffect } from "react";
import SideTabBar from "components/TabBars/SideTabBar";
import TopTabBar from "components/TabBars/TopTabBar";

const TabBar = ({ tabs }) => {
  const [isSmallScreen, setIsSmallScreen] = useState(false);

  useEffect(() => {
    // Ensure this only runs in the browser
    if (typeof window !== "undefined") {
      const handleResize = () => {
        if (window.innerWidth < 800) {
          setIsSmallScreen(true); // Hide sub-sidebar on mobile
        } else {
          setIsSmallScreen(false);
        }
      };

      handleResize(); // Initial check when component mounts

      // Add event listener for window resize
      window.addEventListener("resize", handleResize);

      // Clean up the event listener on unmount
      return () => window.removeEventListener("resize", handleResize);
    }
  }, []);
  return (
    <div>
      {!isSmallScreen && <SideTabBar tabs={tabs} />}
      {isSmallScreen && <TopTabBar tabs={tabs} />}
    </div>
  );
};

export default TabBar;
